import React from 'react';
import Box from '@material-ui/core/Box';

const ProgressBackdrop = ({
  isShow = false,
}) => (
  <>
    {
        isShow && (
          <Box
            position="fixed"
            width="100vw"
            height="calc(100vh - 100px)"
            top="80px"
            left={0}
            zIndex={999999}
          >
            <div className="preorder lds-ripple">
              <div />
              <div />
            </div>
          </Box>
        )
      }
  </>
);

export default ProgressBackdrop;
